/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Error_CancelInputs */

const vi_sl_detail_error_cancel = /** @type {(inputs: Sl_Detail_Error_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi hủy phiếu`)
};

/**

* @param {Sl_Detail_Error_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_error_cancel = /** @type {((inputs?: Sl_Detail_Error_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Error_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_error_cancel(inputs)
});